import { useContext } from 'react'

import { TipoDaBarraSuperior, ContextoDaBarraSuperior } from '../contexts'

export const useBarraSuperior = (): TipoDaBarraSuperior => {
  const contexto = useContext(ContextoDaBarraSuperior)
  return contexto
}
